import { useRoutes } from 'react-router-dom';

// project import
import { appRoutes } from './pageKey';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes(): React.ReactElement | null {
    return useRoutes(appRoutes);
}
